<template>
    <div v-if="trevelerForm.length"
         :class="['treveler-data-block block',{'show': show}]">

        <!--Блок разварачивания-->
        <div @click="blockToggle('trevelerData')"
             class="block-toggle-bar align-center justify-between">
            <div class="block-name align-center justify-center">
                <icon name="profile" width="20px" height="20px" fill="var(--white-color)" fill-opacity="0.7"/>
                <span class="ml-8">{{ localizeList.touristData }}</span>
            </div>
            <icon name="angle" width="12px" height="8px" fill="var(--white-color)" class="angle-icon" />
        </div>
        <div v-show="show" class="treveler-data-content">
            <div v-for="(item, key) in trevelerForm"
                 :key="key"
                 class="treveler-form-wrap">
                <div class="treveler-form-headline">
                    <h3 class="title mb-6">
                        <span>{{ item.title }} </span>
                        <span v-if="key === 0">({{ localizeList.customer.toLowerCase() }})</span>
                    </h3>
                </div>
                <div class="treveler-form">
                    <div v-for="(item2, key2) in item.inputs"
                         :key="`${key}-${key2}`"
                         :class="['field-wrap', item2.Code]">
                        <template v-if="!item2.isGroup">
                            <form-input v-if="item2.type === 'input'"
                                        @input="trevelerValidation(item2, key, key2)"
                                        @blur="translit(item2, key, key2)"
                                        v-model="trevelerInfo[key][key2].value"
                                        :valid="trevelerInfo[key][key2].isValid"
                                        :error="getErrorText(item2)"
                                        customError
                                        :date-mode="isDateMode(item2)"
                                        :date-from="item2.dateFrom"
                                        :date-to="item2.dateTo"
                                        :tabindex="key+1"
                                        :label="item2.label"/>
                            <input-series-number v-else-if="item2.type === 'series-number'"
                                                 @input="trevelerValidation(item2, key, key2)"
                                                 @blur="translit(item2, key, key2)"
                                                 v-model="trevelerInfo[key][key2].value"
                                                 :lengths="item2.lengths"
                                                 :valid="trevelerInfo[key][key2].isValid"
                                                 :tabindex="key+1"
                                                 :label="item2.label"/>
                            <form-auto-complete v-else
                                                v-model="trevelerInfo[key][key2].value"
                                                @change="trevelerInfo[key][key2].value = $event,  trevelerValidation(item2, key, key2)"
                                                @focus="setListByCode(item2.Code)"
                                                @loadMoreItems="loadMoreItemsByCode(item2.Code)"
                                                :load-items="getLoadItemsByCode(item2.Code)"
                                                :items="getListByCode(item2.Code)"
                                                :label="item2.label"
                                                :tabindex="key+1"
                                                :valid="trevelerInfo[key][key2].isValid"/>
                        </template>
                        <div v-else class="group-field">
                            <div v-for="(item3, key3) in item2.items"
                                 :key="key3"
                                 :class="['field-wrap', item3.Code]">
                                <form-input v-if="item3.type === 'input'"
                                            @input="trevelerValidation(item3, key, key2, key3, $event)"
                                            @blur="translit(item2, key, key2, key3)"
                                            v-model="trevelerInfo[key][key2][key3].value"
                                            :valid="trevelerInfo[key][key2][key3].isValid"
                                            :error="getErrorText(item3)"
                                            customError
                                            :date-mode="isDateMode(item3)"
                                            :date-from="item3.dateFrom"
                                            :date-to="item3.dateTo"
                                            :tabindex="key+1"
                                            :label="item3.label"/>
                                <form-auto-complete v-else
                                                    v-model="trevelerInfo[key][key2][key3].value"
                                                    @change="trevelerInfo[key][key2][key3].value = $event"
                                                    :items="trevelerGender[key]"
                                                    :label="item3.label"
                                                    select-mode
                                                    :tabindex="key+1"
                                                    :valid="trevelerInfo[key][key2][key3].isValid"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="item.services.length && checkIsHooded" class="treveler-service-wrap">
                    <insurance v-if="showInsurance(item.services)"
                               :key="key+'insurance'"
                               :services="item.services"
                               :insuranceItems="insuranceItems"
                               :insuranceValue="insuranceValue"
                               :index="key"
                               :tourRate="tourRate"
                               @changeTrevelerService="changeTrevelerService(key, ...$event)"
                               class="treveler-service"/>
                    <visa v-if="showVisa(item.services)"
                          :key="key+'visa'"
                          :services="item.services"
                          :visaItems="visaItems"
                          :visaValue="visaValue"
                          :index="key"
                          :tourRate="tourRate"
                          @changeTrevelerService="changeTrevelerVisa(key, ...$event)"
                          class="treveler-service"/>
                    <template v-for="(item2, key2) in item.services">
                        <div v-if="item2.svKey === 13" :key="key2" class="treveler-service">
                            <div class="treveler-service-name align-center">
                                <icon name="hotel" width="21px" height="18px" fill="var(--lighten-5-color)" />
                                <span class="ml-6 mr-6">{{ localizeList.servicesForHotels }}</span>
                                <div class="popover-link"
                                     @mouseleave="hidePopover()"
                                     @mouseenter="showPopover(item2.title, $event)">
                                    <icon name="info" width="20px" height="20px" fill="var(--lighten-5-color)" />
                                </div>
                            </div>
                            <hotel-select
                                    :items="item2.items"
                                    :rate="tour.Rate"
                                    @change="changeHotelService($event, key)"/>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import InputSeriesNumber from "../inputs/inputSeriesNumber";
    import Insurance from "../individualServices/insurance";
    import Visa from "../individualServices/visa";
    import HotelSelect from "../hotelSelect";
    export default {
        name: "traveler",
        components: {HotelSelect, Visa, Insurance, InputSeriesNumber},
        props: {
            tour: {
                type: Object,
                default: () => {}
            },
            trevelerForm: {
                type: Array,
                default: () => []
            },
            trevelerInfo: {
                type: Array,
                default: () => []
            },
            insuranceItems: {
                type: Array,
                default: () => []
            },
            insuranceValue: {
                type: Array,
                default: () => []
            },
            visaItems: {
                type: Array,
                default: () => []
            },
            visaValue: {
                type: Array,
                default: () => []
            },
            trevelerGender: {
                type: Array,
                default: () => []
            },
            citizenshipList: {
                type: Array,
                default: () => []
            },
            show: {
                type: Boolean,
                default: true
            },
            tourRate: {
                type: String,
                default: ""
            }
        },
        computed: {
            checkIsHooded() {
              return this.trevelerForm.some(x => x.services.some(x2 => x2.items.some(x3 => !x3.isHooded)));
            },
        },
        methods: {
            getLoadItemsByCode(code) {
                this.$emit("getLoadItemsByCode", code)
            },
            loadMoreItemsByCode(code) {
                this.$emit("loadMoreItemsByCode", code)
            },
            setListByCode(code) {
                this.$emit("setListByCode", code)
            },
            isDateMode(item) {
                return item.Code.includes("date")
            },
            getErrorText(item) {
                return `${this.localizeList.wrongValue} "${item.HeaderText.split('<')[0]}"`
            },
            changeHotelService(e, key) {
                this.$emit("changeHotelService", [e, key])
            },
            changeTrevelerVisa(key, e, key2) {
                this.$emit("changeTrevelerVisa", [key, e, key2])
            },
            changeTrevelerService(key, e, key2) {
                this.$emit("changeTrevelerService", [key, e, key2])
            },
            translit(item, key1, key2, key3 = null) {
                this.$emit("translit", [item, key1, key2, key3])
            },
            trevelerValidation(item, key1, key2, key3 = null) {
                this.$emit("trevelerValidation", [item, key1, key2, key3])
            },
            blockToggle() {
                this.$emit("toggle", !this.show)
            },
            showVisa(services) {
                return services.map(x => x.svKey).includes(5) && services.filter(x => x.svKey === 5).some(x2 => x2.items.some(x3 => !x3.isHooded));
            },
            showInsurance(services) {
                return services.map(x => x.svKey).includes(6) && services.filter(x => x.svKey === 6).some(x2 => x2.items.some(x3 => !x3.isHooded));
            },
            getListByCode(code) {
                let res = [];
                if (code === "citizenship") {
                    res = this.citizenshipList.map(x => {
                        return {
                            value: x.Key,
                            text: x.Name,
                            isShow: true
                        }
                    })
                }
                return res
            },
            showPopover(text, e) {
                let rect = e.target.getBoundingClientRect();
                let res = {
                    x: rect.left + (rect.width / 2),
                    y: rect.top,
                    text: text,
                    height: rect.height
                }
                this.$store.dispatch("A_SHOW_POPOVER", res);
            },
        }
    }
</script>

<style scoped>
    .block {
        background: var(--white-color);
        box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.11);
        border-radius: 4px;
        margin-bottom: 12px;
        transition: all .3s;
    }

    .block .block-toggle-bar {
        border-radius: 4px;
        background: var(--primary-color);
        padding: 12px 16px;
        cursor: pointer;
    }

    .block.show .block-toggle-bar {
        border-radius: 4px 4px 0 0;
    }

    .block .block-toggle-bar .block-name span {
        font-weight: bold;
        font-size: 15px;
        line-height: 18px;
        color: var(--white-color);
    }

    .block .block-toggle-bar .angle-icon {
        transform: rotate(0deg);
        transition: all .2s;
    }

    .block.show .block-toggle-bar .angle-icon {
        transform: rotate(180deg);
        transition: all .2s;
    }

    /***BLOCK TREVELER DATA***/
    .basket .treveler-data-block .treveler-form-wrap {
        padding: 24px 28px;
    }

    .basket .treveler-data-block .treveler-form-wrap:not(:last-child) {
        border-bottom: 1px dashed var(--lighten-4-color);
    }

    .basket .treveler-data-block .treveler-form-wrap .title {
        font-weight: bold;
        font-size: 18px;
        line-height: 21px;
        color: #1D1D1D;
    }

    .basket .treveler-data-block .treveler-form-wrap .treveler-form {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-column-gap: 20px;
        grid-row-gap: 24px;
    }

    .ie .basket .treveler-data-block .treveler-form-wrap .treveler-form {
        display: flex;
        flex-wrap: wrap;
    }

    .ie .basket .treveler-data-block .treveler-form-wrap .treveler-form .field-wrap {
        width: 32%;
        margin-right: 1%;
    }

    .basket .treveler-data-block .treveler-form-wrap .treveler-form .group-field {
        display: grid;
        grid-template-columns: 1fr 60px;
        grid-gap: 20px;
    }

    .ie .basket .treveler-data-block .treveler-form-wrap .treveler-form .group-field {
        display: flex;
    }

    .ie .basket .treveler-data-block .treveler-form-wrap .treveler-form .group-field .field-wrap:last-child {
        width: 60px;
        margin-left: 2%;
    }

    .ie .basket .treveler-data-block .treveler-form-wrap .treveler-form .group-field .field-wrap:first-child {
        width: 100%;
        margin-right: 0;
    }

    .basket .treveler-data-block .treveler-service-wrap {
        background: var(--lighten-2-color);
        border-radius: 6px;
        padding: 16px;
        margin-top: 20px;
    }

    .basket .treveler-data-block .treveler-service-wrap .treveler-service {
        display: grid;
        grid-template-columns: minmax(250px, auto) 1fr;
        grid-gap: 20px;
    }

    .ie .basket .treveler-data-block .treveler-service-wrap .treveler-service {
        display: flex;
    }

    .ie .basket .treveler-data-block .treveler-service-wrap .treveler-service .treveler-service-name {
        min-width: 250px;
        margin-right: 20px;
    }

    .basket .treveler-data-block .treveler-service-wrap .treveler-service:not(:last-child) {
        margin-bottom: 12px;
    }

    .basket .treveler-data-block .treveler-service-wrap .treveler-service /deep/ .base-select .select {
        background-color: var(--white-color);
        padding-top: 8px;
        padding-bottom: 8px;
        padding-right: 26px;
    }
</style>